import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { ButtonComponent } from '@finder/shared/components/button/button.component';
import { FontIconComponent } from '@finder/shared/components/font-icon/font-icon.component';

import { SquirtData, SquirtMediaDetails } from '@finder/shared/features/squirt/squirt.interface';
import { DebugLogService } from '@finder/shared/services/debug-log/debug-log.service';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';

@Component({
    selector: 'finder-squirt',
    templateUrl: './squirt-results.component.html',
    styleUrls: ['./squirt-results.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ButtonComponent,
        FontIconComponent,
    ],
})
export class SquirtResultsComponent implements OnInit {
    @Input() mediaData: SquirtData;

    toggleIcon: string;
    mediaDetailsReadable: string | null = null;
    copiedHide = 'hide';

    private norgieOpened = 'norgie-opened';
    private norgieClosed = 'norgie-closed';

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private windowRef: WindowRef,
        private debugLog: DebugLogService,
        @Inject(DOCUMENT) private document: Document,
    ) {}

    ngOnInit() {
        this.toggleIcon = this.norgieOpened;
    }

    toggle() {
        if (this.toggleIcon === this.norgieOpened) {
            this.toggleIcon = this.norgieClosed;
            this.document.body.style.setProperty('--squirt-results-height', '35px');
            this.document.body.style.setProperty('--squirt-avatar-display', 'none');
            this.document.body.style.setProperty('--squirt-content-display', 'none');
        } else {
            this.toggleIcon = this.norgieOpened;
            this.document.body.style.setProperty('--squirt-results-height', 'unset');
            this.document.body.style.setProperty('--squirt-avatar-display', 'unset');
            this.document.body.style.setProperty('--squirt-content-display', 'unset');
        }
    }

    remove() {
        // Find all the labels and remove them from the DOM
        (this.document.body.querySelectorAll('.squirt-overlay') || []).forEach(node => {
            node.remove();
        });

        // Remove any css vars on the body
        this.document.body.style.removeProperty('--squirt-results-height');
        this.document.body.style.removeProperty('--squirt-avatar-display');
        this.document.body.style.removeProperty('--squirt-content-display');

        // Remove this component
        this.renderer.removeChild(this.document.body, this.elementRef.nativeElement);
    }

    setDetails(size) {
        // First, make sure the string is reset
        this.hideDetails();

        // Now, reduce the details
        this.mediaDetailsReadable = this.mediaData.mediaDetails
            // Return "all" or the matching subset
            .filter(media => size === 'total' ? media : media.category === size)
            .sort(media => media.size)
            .reduce((acc: string, media: SquirtMediaDetails) => {
                acc += `${media.file} - ${media.readableSize}\n`;

                return acc;
            }, '');
    }

    hideDetails() {
        this.mediaDetailsReadable = null;
    }

    copy() {
        this.windowRef.nativeWindow.navigator.clipboard.writeText(this.mediaDetailsReadable)
            .then(() => {
                this.debugLog.info('***** Copied to clipboard!');
                this.copiedHide = '';
                setTimeout(() => {
                    this.copiedHide = 'hide';
                }, 3000);
            });
    }
}
